import { render, staticRenderFns } from "./field-details.vue?vue&type=template&id=5542bc80&scoped=true"
import script from "./field-details.vue?vue&type=script&lang=js"
export * from "./field-details.vue?vue&type=script&lang=js"
import style0 from "./field-details.vue?vue&type=style&index=0&id=5542bc80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5542bc80",
  null
  
)

export default component.exports